<template>
  <div v-if="distribution && distribution.actions">
    <v-sheet class="pt-1 transparent-background-color d-inline-block">
      <!-- 明细 -->
      <v-tooltip
        top
        v-if="showView && $permission.permissionAllow('Distributions', 'view')"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="info"
            class="px-2 me-2 mb-1"
            :href="'/#/distributions/' + distribution.id"
          >
            <v-icon x-small class="pe-1">fa-align-left</v-icon>
            {{ $t("Opt.details") }}
          </v-btn>
        </template>
        <span>{{ $t("CRUD.viewInfo", [$t("Distribution.ObjectName")]) }}</span>
      </v-tooltip>
      <!-- 配送 -->
      <v-tooltip
        top
        v-if="
          showDistribute &&
          $permission.permissionAllow('Distributions', 'distribute')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="primary"
            class="px-2 me-2 mb-1"
            @click.stop="$emit('distribute', distribution)"
          >
            {{ $t("Distribution.actions.distribute") }}
          </v-btn>
        </template>
        <span>{{ $t("Distribution.actions.distribute") }}</span>
      </v-tooltip>
      <!-- 物流 -->
      <v-tooltip
        top
        v-if="
          showLogistic &&
          $permission.permissionAllow('Distributions', 'editLogistics')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            :outlined="!distribution.logistics_id"
            color="orange"
            class="px-2 me-2 mb-1"
            @click.stop="
              (distribution.logistics_supplier_flg) ? logisticAlert = true : editLogisticAlert = true
            "
          >
            {{ $t("Distribution.actions.logistic") }}
          </v-btn>
        </template>
        <span>{{ $t("Distribution.actions.logistic") }}</span>
      </v-tooltip>
      <!-- 跟踪物流 -->
      <v-tooltip top v-if="showKdnLogistic && distribution.express_url">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="orange"
            class="px-2 me-2 mb-1"
            :href="distribution.express_url"
          >
            {{ $t("Distribution.actions.kdnLogistic") }}
          </v-btn>
        </template>
        <span>{{ $t("Distribution.actions.kdnLogistic") }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-else-if="showKdnLogistic && distribution.actions.kdn_logistic"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="orange"
            class="px-2 me-2 mb-1"
            @click.stop="kdnLogisticAlert = true"
          >
            {{ $t("Distribution.actions.kdnLogistic") }}
          </v-btn>
        </template>
        <span>{{ $t("Distribution.actions.kdnLogistic") }}</span>
      </v-tooltip>
      <!-- 打印 -->
      <v-tooltip
        top
        v-if="$permission.permissionAllow('Distributions', 'print')"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="print"
            class="px-2 me-2 mb-1"
            @click.stop="doPrint('distributionPrint')"
          >
            <v-icon x-small class="pe-1">fa-print</v-icon>
            {{ $t("Print.print") }}
            <span v-if="distribution.print_count">
              {{ $t("Global.brackets", [distribution.print_count]) }}
            </span>
          </v-btn>
        </template>
        <span>{{ $t("Distribution.actions.printDistribution") }}</span>
      </v-tooltip>

      <!-- 云打印 -->
      <v-tooltip
        top
        v-if="
          $permission.permissionAllow('Distributions', 'print') &&
          $permission.permissionAllow('CloudPrints', 'index') &&
          settings && settings.cloud_print_enable
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="print"
            class="px-2 me-2 mb-1"
            @click.stop="doCloudPrint('distribution')"
          >
            <v-icon x-small class="pe-1">fa-print</v-icon>
            {{ $t("Print.cloud_print") }}
            <span v-if="distribution.print_count">
              {{ $t("Global.brackets", [distribution.print_count]) }}
            </span>
          </v-btn>
        </template>
        <span>{{ $t("Distribution.actions.printDistribution") }}</span>
      </v-tooltip>

      <!-- 导出 -->
      <!-- TODO：缺接口 -->
      <v-tooltip
        top
        v-if="$permission.permissionAllow('Distributions', 'export')"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="print"
            class="px-2 me-2 mb-1"
          >
            <v-icon x-small class="pe-1">fa-file-export</v-icon>
            {{ $t("Export.export", [""]) }}
          </v-btn>
        </template>
        <span>{{ $t("Distribution.actions.exportDistribution") }}</span>
      </v-tooltip>
    </v-sheet>

    <EditLogisticAlert
      v-model="editLogisticAlert"
      :distribution="distribution"
      @editLogistic="$emit('editLogistic')"
    />
    <LogisticAlert
      v-model="logisticAlert"
      :distribution="distribution"
    />
    <KdnLogisticAlert
      v-model="kdnLogisticAlert"
      :distribution="distribution"
      :distributionCode="distribution.distributions_code"
      persistent
    />
  </div>
</template>
<script>
import EditLogisticAlert from "./EditLogisticAlert";
import LogisticAlert from "./LogisticAlert";
import KdnLogisticAlert from "./KdnLogisticAlert";
import makeData from "../makeData";
import Distributions from "@/api/distributions";
import CloudPrintTemplates from "@/api/cloud_print_templates";
import {mapState} from "vuex";

export default {
  name: "DistributionActions",

  props: {
    distribution: Object,
    detailMode: Boolean,
    showView: Boolean,
    showDistribute: Boolean,
    showLogistic: Boolean,
    showKdnLogistic: Boolean,
  },

  components: {
    LogisticAlert,
    EditLogisticAlert,
    KdnLogisticAlert,
  },

  computed: {
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["settings", "accountUser"]),
  },

  data: () => ({
    printBtnMenu: false,
    exportBtnMenu: false,
    logisticAlert: false,
    editLogisticAlert: false,
    kdnLogisticAlert: false,
  }),

  methods: {
    doPrint(mode) {
      this.$permission.checkAccountExpired().then(
        function () {
          switch (mode) {
            case "distributionPrint":
              this.$router.push(
                "/print/distribution-print/" + this.distribution.id
              );
              break;
          }
        }.bind(this)
      );
    },
    doCloudPrint(mode) {
      this.$permission.checkAccountExpired().then(
        function () {
          if (mode == 'distribution') {
            Distributions.distributionPrint(this.distribution.id).then(
              function (response) {
                if (response.data.status.isOK()) {
                  var distribution = response.data.distribution;
                  distribution = makeData.processDetails(distribution);
                  distribution.order.shop = this.$printUtils.addCitiesName(distribution.order.shop);
                  distribution.distribution_details.map((detail) => {
                    detail.print_date = new Date().toISOString().substr(0, 10);
                    return detail;
                  });
                  CloudPrintTemplates.print({
                    print_template_code: mode,
                    object: {
                      distribution: distribution,
                      order: distribution.order,
                      order_address: response.data.order_address,
                      print_date: new Date().toISOString().substr(0, 10),
                    }
                  })
                }
              }.bind(this)
            );
          }
        }.bind(this)
      );
    }
  },
};
</script>